module.exports = __webpack_public_path__ + "img/IG.c9d9f0a4.svg";